import { render, staticRenderFns } from "./ModalMessage.vue?vue&type=template&id=267a5ce8&scoped=true"
import script from "./ModalMessage.vue?vue&type=script&lang=js"
export * from "./ModalMessage.vue?vue&type=script&lang=js"
import style0 from "./ModalMessage.vue?vue&type=style&index=0&id=267a5ce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267a5ce8",
  null
  
)

export default component.exports